import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Using `}<inlineCode parentName="p">{`identify`}</inlineCode>{`, you can associate events with specific users. This enables you to gain full insights as to how they're using your product across different sessions, devices, and platforms.`}</p>
    <p>{`An `}<inlineCode parentName="p">{`identify`}</inlineCode>{` call has the following arguments:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`userId:`}</strong>{` Required. A unique identifier for your user. Typically either their email or database ID.`}</li>
      <li parentName="ul"><strong parentName="li">{`userProperties:`}</strong>{` Optional. A dictionary with key:value pairs to set the `}<a parentName="li" {...{
          "href": "/docs/product-analytics/person-properties"
        }}>{`person properties`}</a></li>
      <li parentName="ul"><strong parentName="li">{`userPropertiesSetOnce:`}</strong>{` Optional. Similar to `}<inlineCode parentName="li">{`userProperties`}</inlineCode>{`. `}<a parentName="li" {...{
          "href": "/docs/product-analytics/person-properties#what-is-the-difference-between-set-and-set_once"
        }}>{`See the difference between `}<inlineCode parentName="a">{`userProperties`}</inlineCode>{` and `}<inlineCode parentName="a">{`userPropertiesSetOnce`}</inlineCode></a></li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-dart"
      }}>{`await Posthog().identify(
  userId: emailController.text, 
  userProperties: {"name": "Peter Griffin", "email": "peter@familyguy.com"},
  userPropertiesSetOnce: {"date_of_first_log_in": "2024-03-01"}
);
`}</code></pre>
    <p>{`You should call `}<inlineCode parentName="p">{`identify`}</inlineCode>{` as soon as you're able to. Typically, this is after your user logs in. This ensures that events sent during your user's sessions are correctly associated with them.`}</p>
    <p>{`When you call `}<inlineCode parentName="p">{`identify`}</inlineCode>{`, all previously tracked anonymous events will be linked to the user.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      